import { SortBy, SORTING_DIR } from "@/common/models";
import { Restriction } from "@/common/models/admin-restrictions.model";
/* 
https://dev.azure.com/shieldox/X2O/_workitems/edit/11163
ar01 - restrict access to Add Admin API
ar02 - restrict access to Change Restrictions API
*/

export interface AdminUser {
  id: number;
  associatedOrg: string;
  email: string;
  status: UserStatus;
  role: UserRole;
  restrictions: Restriction[];
}

export enum UserPermissions {
  LIMITED_RIGHTS = "LIMITED_RIGHTS",
  ALL_RIGHTS = "LIMITED_RIGHTS",
  VIEW_ONLY = "VIEW_ONLY",
}

export enum UserRole {
  ADMIN = "Admin",
  SUPER_ADMIN = "SuperAdmin",
  SYSTEM_ADMIN = "system",
  BUSINESS_ADMIN = "business",
}

export enum UserStatus {
  ACTIVE = "Active",
  PENDING = "Pending",
  BLOCKED = "Blocked",
}

export interface AdminsState {
  totalCount: number;
  admins: AdminUser[];
  sortBy: SortBy;
}

export const SEED: AdminsState = {
  admins: [],
  totalCount: 0,
  sortBy: { key: "email", dir: SORTING_DIR.DESC },
};
